import { render, staticRenderFns } from "./trainKnowledge.vue?vue&type=template&id=29d585b5&scoped=true"
import script from "./trainKnowledge.vue?vue&type=script&lang=js"
export * from "./trainKnowledge.vue?vue&type=script&lang=js"
import style0 from "./trainKnowledge.vue?vue&type=style&index=0&id=29d585b5&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "29d585b5",
  null
  
)

export default component.exports